import React from "react"
import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";

const SectionDetails = (props) => {
    return (
        <Box spacingInset="small none">
            <Row>
                <Text type="h200">{props.title}</Text></Row>
            <Row>
                <Text color="secondary" type="b200">{props.description}</Text>
            </Row>
        </Box>
    );
}

export default SectionDetails;


// WEBPACK FOOTER //
// ./src/component/modal/deposit/sectionDetails.js